import { startOfDay, addDays, subDays, format, endOfDay } from 'date-fns';
import { isNil } from 'lodash';
import axios from 'axios';
import { sendEvents } from '@fiverr-private/futile/lib/send/sendEvents';
import { bigQuery } from '@fiverr-private/obs';

export const submitVacation = async(payload) => {
    const url = `/users/${payload.userId}/vacations`;
    const { data } = await axios.post(url, payload);
    return data;
};

export const turnVacationOff = (username) => {
    const url = `/users/${username}/vacations`;
    return axios.delete(url);
};

export const getDateStringFromTimestamp = (timestamp) => {
    const dateObj = new Date(timestamp);
    const dateString = dateObj.toLocaleString('en-us', { day:'numeric', month: 'short', year:'numeric' });

    return dateString;
};

export const getDateValue = (timestamp) => {
    if (isNil(timestamp)) {
        return '';
    }

    const date = new Date(timestamp);
    return format(date, 'yyyy-MM-dd');
};

export const convertDateValueToTimestamp = (dateValue, atEndOfDay = false) => {
    if (!dateValue) { return null; }

    try {
        let dateString = dateValue;

        if (!atEndOfDay) {
            dateString += ' 00:00:00';
        } else {
            dateString += ' 23:59:59';
        }

        const date = new Date(dateString);
        return date.getTime();
    } catch (err) {
        return null;
    }
};

export const reportEvent = (type, data, other = false) => {

    const groupStr = other ? other : 'out_of_office',
        typeStr = `${!other ? 'out_of_office.' : ''}${type}`;

    let eventData = {
        type : typeStr,
        group: groupStr
    };

    eventData = Object.assign({}, eventData, { ...data });

    if (typeof Fiverr === 'object' && typeof Fiverr.sendClientEvents === 'function') {
        sendEvents(eventData);
    } else {
        bigQuery.send(eventData);
    }
};

export const startOfYesterdayInMillis = () => subDays(new Date(startOfTodayInMillis()), 1).getTime();

export const startOfTodayInMillis = () => startOfDay(new Date()).getTime();

export const startOfTomorrowInMillis = () => addDays(new Date(startOfTodayInMillis()), 1).getTime();

export const endOfTomorrowInMillis = () => endOfDay(addDays(new Date(startOfTodayInMillis()), 1)).getTime();
